import Switch from '@carvana/showroom-forms/Switch';
import React, { useContext } from 'react';
import TradeContext from '~/context/common/TradeContext';
import { GreyBar } from './TradeCard.styles';

type OwnProps = {
  onToggle: React.ChangeEventHandler<HTMLInputElement>;
};

export default function TradeToggle({ onToggle }: OwnProps) {
  const { isTradeInApplied } = useContext(TradeContext);

  return (
    <>
      <GreyBar />

      <div className="flex flex-wrap items-center justify-between gap-8">
        <p className="text-blue-6 tl-body-m">Show pricing with trade-in</p>
        <Switch
          data-qa="apply-trade-in-toggle"
          checked={isTradeInApplied}
          onChange={onToggle}
        />
      </div>
    </>
  );
}
